module.exports = __webpack_public_path__ + "35ef5c5f0c05973a4d6f61bb398de19a.jpg";